import { render } from "./ProfileDropdownMenu.vue?vue&type=template&id=2abd6afd&scoped=true"
import script from "./ProfileDropdownMenu.vue?vue&type=script&lang=js"
export * from "./ProfileDropdownMenu.vue?vue&type=script&lang=js"

import "./ProfileDropdownMenu.vue?vue&type=style&index=0&id=2abd6afd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2abd6afd"]])

export default __exports__